module.exports = "<div class=ui-grid-cell-contents> <div> <i class=\"icon mdi-content-create i-16 text-negro-opacity m-r-sm pointer\" ng-click=grid.appScope.schedulesListVm.getSchedule(row.entity)></i> <i class=\"icon mdi-action-delete i-16 text-negro-opacity m-r-sm pointer\" ng-click=grid.appScope.schedulesListVm.confirmDisableSchedule(row.entity)></i> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/teaching/studentAttention/listSchedules/cellScheduleActions.html
// module id = 737
// module chunks = 0